import {
  makeDataState,
  makeListState,
  makePaginationState,
  concatUnique,
  STATUSES,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  info: makeDataState(),
  fans: makePaginationState(),
  topFans: makeListState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_FAN_CLUB_INFO}_PENDING`:
      return {
        ...state,
        info: {
          ...state.info,
          status: STATUSES.PENDING,
          isLoaded: false,
        },
      };
    case `${t.FETCH_FAN_CLUB_INFO}_SUCCESS`:
      return {
        ...state,
        info: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_FAN_CLUB_INFO}_ERROR`:
      return {
        ...state,
        info: {
          ...state.info,
          status: STATUSES.ERROR,
          isLoaded: false,
        },
      };

    case `${t.FETCH_FAN_CLUB_USERS}_PENDING`:
      return {
        ...state,
        fans: {
          ...state.fans,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_FAN_CLUB_USERS}_SUCCESS`:
      return {
        ...state,
        fans: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.fans.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_FAN_CLUB_USERS}_ERROR`:
      return {
        ...state,
        fans: {
          ...state.users,
          status: STATUSES.ERROR,
          isLoaded: false,
        },
      };

    case `${t.PATCH_MY_FAN_CLUB_INFO}_SUCCESS`:
      return {
        ...state,
        info: {
          ...state.info,
          data: action.payload.result,
        },
      };

    case t.RESET:
      return {
        ...state,
        info: makeDataState(),
        fans: makePaginationState(),
      };

    case `${t.FETCH_FAN_CLUB_TOP_USERS}_PENDING`:
      return {
        ...state,
        topFans: {
          ...state.topFans,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_FAN_CLUB_TOP_USERS}_SUCCESS`:
      return {
        ...state,
        topFans: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_FAN_CLUB_TOP_USERS}_ERROR`:
      return {
        ...state,
        topFans: {
          ...state.topFans,
          status: STATUSES.ERROR,
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/fanClub/reducer.js